import { BELTS } from "../lib/api";

export const PageHeader = ({ eyebrow, title, subtitle, action }) => (
  <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8 dx-rise">
    <div>
      {eyebrow && <div className="dx-eyebrow mb-2">{eyebrow}</div>}
      <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#250E31]" data-testid="page-title">{title}</h1>
      {subtitle && <p className="text-sm sm:text-base text-[#6b5a73] mt-2 max-w-2xl">{subtitle}</p>}
    </div>
    {action}
  </div>
);

export const StatCard = ({ label, value, icon: Icon, testid, accent = false }) => (
  <div className={`rounded-2xl p-5 border dx-rise ${accent ? "bg-[#5B2A6E] text-white border-transparent" : "dx-card"}`} data-testid={testid}>
    <div className="flex items-center justify-between">
      <span className={`text-xs uppercase tracking-[0.14em] font-semibold ${accent ? "text-[#D4AF37]" : "text-[#8a7a92]"}`}>{label}</span>
      {Icon && <Icon className={`w-4 h-4 ${accent ? "text-[#D4AF37]" : "text-[#5B2A6E]"}`} />}
    </div>
    <div className="font-display text-3xl font-bold mt-3">{value}</div>
  </div>
);

export const BeltBadge = ({ belt = "none", testid }) => {
  const b = BELTS[belt] || BELTS.none;
  return (
    <span data-testid={testid} className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold" style={{ background: b.bg, color: b.color }}>
      <span className="w-2 h-2 rounded-full" style={{ background: b.color }} />
      {b.label}
    </span>
  );
};

const STATUS = {
  applied: "bg-slate-100 text-slate-700", shortlisted: "bg-[#FFF4D4] text-[#8a6a00]", interview: "bg-sky-100 text-sky-800",
  offered: "bg-violet-100 text-violet-800", hired: "bg-emerald-100 text-emerald-800", rejected: "bg-rose-100 text-rose-700",
  pending: "bg-slate-100 text-slate-700", in_progress: "bg-[#FFF4D4] text-[#8a6a00]", done: "bg-emerald-100 text-emerald-800",
  open: "bg-emerald-100 text-emerald-800", closed: "bg-slate-200 text-slate-600", working: "bg-emerald-100 text-emerald-800",
  on_break: "bg-[#FFF4D4] text-[#8a6a00]", off: "bg-slate-100 text-slate-600",
};

export const StatusPill = ({ status, testid }) => (
  <span data-testid={testid} className={`inline-block rounded-full px-2.5 py-0.5 text-xs font-semibold capitalize ${STATUS[status] || STATUS.pending}`}>
    {String(status || "").replace("_", " ")}
  </span>
);

export const Empty = ({ icon: Icon, title, text, testid }) => (
  <div className="dx-card p-10 text-center" data-testid={testid}>
    {Icon && <Icon className="w-8 h-8 mx-auto text-[#D4AF37]" />}
    <div className="font-display font-semibold text-lg mt-3 text-[#250E31]">{title}</div>
    {text && <p className="text-sm text-[#6b5a73] mt-1 max-w-sm mx-auto">{text}</p>}
  </div>
);

export const Field = ({ label, children }) => (
  <label className="block">
    <span className="dx-label">{label}</span>
    {children}
  </label>
);
